import { useState, useRef, useEffect } from 'react';
import { Row, Col, FormGroup, Label } from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

import { OptionsContainer } from '../../FormMessagesBuilder.styles';

import CustomTextAreaWithEditor from '../../../../common/CustomTextAreaWithEditor.component';

import { Container } from './CreateBodyWaba.styles';

import AddVariable from '../../common/variable/AddVariable.component';

interface CreateBodyWabaProps {
  onUpdate: (value: string) => void;
  initialValue: {
    text: string;
  };
  isEdit: boolean;
}

function CreateBodyWaba({
  onUpdate,
  initialValue,
  isEdit,
}: CreateBodyWabaProps) {
  // Traduções
  const message = useGlotaT('spa.messageBuilder.message');
  const messageBody = useGlotaT('spa.messageBuilder.messageBody');
  
  const [bodyData, setBodyData] = useState(initialValue);

  const handleInputChange = (value: string) => {
    setBodyData({
      ...bodyData,
      text: value,
    });
    handleBodyData({
      ...bodyData,
      text: value,
    });
  };

  const handleAddVariable = (data: any) => {
    const { variable } = data;
    const newText = bodyData.text + variable;

    console.log('newText => ', newText);

    setBodyData({
      ...bodyData,
      text: newText,
    });
    handleBodyData({
      ...bodyData,
      text: newText,
    });
  };

  const handleBodyData = (data: any) => {
    onUpdate(data);
  };

  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          <Label>{message}</Label>
          <Container>
            <CustomTextAreaWithEditor
              disabled={isEdit}
              id="body-message"
              maxLength={1024}
              onChange={handleInputChange}
              placeholder={messageBody}
              required
              showCharCounter
              value={bodyData.text}
            >
              <AddVariable onUpdate={handleAddVariable} isEdit={isEdit} />
            </CustomTextAreaWithEditor>
            <OptionsContainer></OptionsContainer>
          </Container>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CreateBodyWaba;
